var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionRectangle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 36,
    viewBox: "0 0 4 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 36,
    rx: 2,
    fill: "#FFAB2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionRectangle);
export default __webpack_public_path__ + "static/media/accordion-rectangle.2d80a77d690f94e29c347323592f423a.svg";
export { ForwardRef as ReactComponent };